import React, { useState, useEffect, useRef } from 'react';
import { getSoundPropsById } from '../../lib/ep.js';
import ReactHowler from 'react-howler';

import Select from './Select.js';
import { SquaredButton } from './ActionButton.js';
import ButtonCollection from './ButtonCollection.js';

export const SimpleAudioControls = ({ audio, ...props }) => {
	const [ is_playing, setIsPlaying ] = useState(false);
	const player_ref = useRef(false);

	if(audio == undefined || audio == 'none' || (props?.disabled ?? false)) {
		return (
			<SquaredButton
				icon='ep-play'
				disabled={true}
			/>
		)
	}

	const is_builder = props?.is_builder ?? false;
	const custom_soundfile = props?.is_custom ?? false;

	let audio_props = {};
	if(custom_soundfile) {
		audio_props = {
			src:audio,
			...props.extra_props,
		};
	} else {
		audio_props = getSoundPropsById(audio, props.extra_props, true);
	}

	const stopSound = () => {
		player_ref.current.stop();
	};

	const playSound = () => {
		player_ref.current.seek(0);
		player_ref.current.play();
	};

	const toggleSound = () => {
		const new_status = !is_playing;
		setIsPlaying(new_status);

		if(new_status) {
			playSound();
			return;
		}

		stopSound();
	};

	return (
		<>
			<SquaredButton
				icon={(is_playing) ? 'ep-pause' : 'ep-play'}
				onClick={toggleSound}
			/>

			<ReactHowler
				ref={(node) => { player_ref.current = node; }}
				{...audio_props}
				playing={is_playing}
				onEnd={() => {
					if(is_builder && (audio_props?.loop ?? false)) return;
					setIsPlaying(false);
				}}
			/>
		</>
	)
};

const SoundSelect = (props) => {
	const [ is_enabled, setIsEnabled ] = useState(false);

	const model = props?.model ?? {};
	const name = props?.name ?? false;
	const values = props?.values ?? [];

	const getValue = () => {
		if(name.indexOf(".") < 0) return model[name];

		let final_name = model;
		name.split(".").map((part) => {
			if(final_name[part] == undefined) return;
			final_name = final_name[part];
		});

		if(typeof(final_name) != 'string') return values[0]?.k ?? 'none';

		return final_name;
	};

	const value = getValue();

	const hasAnySound = () => {
		if(value == undefined) return false;
		if(value == 'none') return false;
		return true;
	};

	useEffect(() => {
		const has_sound = hasAnySound();
		setIsEnabled((has_sound) ? true : false);
	}, [ value ]);

	return (
		<Select
			{...props}
			field_extra_classes='with_floating_button'
			overlapped_content={<ButtonCollection
				_class={{ other:'preview_btn' }}
			>
				<SimpleAudioControls
					audio={value}
					disabled={!is_enabled}
					is_builder={true}
				/>
			</ButtonCollection>}
		/>
	);
}

export default SoundSelect;